// @core/api/endpoints/task/get_available_transitions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetAvailableTransitionsResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Get available transitions
 * Returns the list of status transitions available from the task's current status, based on the task type's transition rules. If no rules are defined, returns all statuses (free transitions).
 */
export async function GetAvailableTransitions(
  task_id: string,
  options?: RequestOptions
): Promise<GetAvailableTransitionsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/transitions`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  const requestOptions = options;
  return client.get<GetAvailableTransitionsResponse>(requestPath, { ...requestOptions });
}
